import { useTheme } from "../context/ThemeContext";

const UserIcon = ({ active, color }) => {
  const { darkMode } = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9621 15H14.3297C15.1921 15 15.878 14.6071 16.4939 14.0577C18.0585 12.6619 14.3806 11.25 13.125 11.25M11.625 3.80158C11.7953 3.7678 11.9722 3.75 12.1536 3.75C13.5185 3.75 14.625 4.75736 14.625 6C14.625 7.24264 13.5185 8.25 12.1536 8.25C11.9722 8.25 11.7953 8.2322 11.625 8.19842"
        stroke={active ? "white" : "#828282"}
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M3.36098 12.0834C2.47675 12.5572 0.158353 13.5248 1.57041 14.7356C2.26019 15.327 3.02843 15.75 3.99429 15.75H9.50571C10.4716 15.75 11.2398 15.327 11.9296 14.7356C13.3416 13.5248 11.0232 12.5572 10.139 12.0834C8.06551 10.9722 5.43449 10.9722 3.36098 12.0834Z"
        stroke={active ? "white" : "#828282"}
        stroke-width="1.5"
      />
      <path
        d="M9.75 5.625C9.75 7.28185 8.40685 8.625 6.75 8.625C5.09315 8.625 3.75 7.28185 3.75 5.625C3.75 3.96815 5.09315 2.625 6.75 2.625C8.40685 2.625 9.75 3.96815 9.75 5.625Z"
        stroke={active ? "white" : "#828282"}
        stroke-width="1.5"
      />
    </svg>
  );
};

export default UserIcon;
